<template lang="pug">
  div.comments
    md-field.comment-field
      label Комментарий
      md-textarea.edit-comment(v-bind:disabled="sending" v-model="comment.text" v-validate="'required'" name="new_comment"  v-on:focus="showCommentButton = true" v-on:blur="hideCommentButton")
    .md-layout.md-alignment-top-right
      md-button.md-primary.md-raised.md-dense(v-show="showCommentButton" v-on:click="saveComment(comment)") Отправить

    .items(v-if="Object.keys(comments).length")
      .comment(v-for="comment in comments" v-bind:key="comment.id")
        template(v-if="$store.state.users.current.id == comment.user_id")
          .md-layout
            div
              .user {{ comment.user.login }}
              .date {{ comment.created_at }}
            .md-layout-item.md-layout.md-alignment-top-right.actions
              md-button.small.md-dense.md-icon-button.edit(v-on:click.stop.prevent="comment.edit = 1; comment.oldText = comment.text;"): md-icon edit
              md-button.small.md-dense.md-icon-button.edit(v-on:click.stop.prevent="deleteComment(comment.id)"): md-icon close
          .text {{ comment.text }}
        md-field(v-bind:class="{ 'md-invalid': errors.has('edit_comment') }" v-show="comment.edit === 1")
          label Комментарий
          md-textarea#edit-comment(v-bind:disabled="sending" v-model="comment.text" name="edit_comment")
          md-button.md-dense.md-icon-button(v-on:click="saveComment(comment)"): md-icon done
          md-button.md-dense.md-icon-button.md-warn(v-on:click="comment.edit = 0; comment.text = comment.oldText;"): md-icon close
</template>
<script>
  import moment from "moment"
  export default {
    name: 'comments',
    props: [
      'module',
      'entity',
      'entity_id'
    ],
    data() {
      return {
        comments: [],
        comment: {
          text: ''
        },
        sending: false,
        showCommentButton: false,
      }
    },
    created() {
      this.getComments();
    },
    watch: {
      '$props.entity_id'() {
        this.getComments();
      }
    },
    computed: {

    },
    methods: {

      //удаление комментария
      deleteComment(comment_id) {
        this.$store.commit('showProgressBar'); this.sending = true; let self = this;
        //удаляем комментарий из задачи, к которому он прикреплён
        this.comments.forEach((comment, index) => {
          if (comment.id == comment_id) this.comments.splice(index, 1)
        });
        this.$store.dispatch('comments/deleteComment', { comment_id: comment_id }).then(response => {
          self.getComments(); this.sending = false; this.$store.commit('hideProgressBar');
        }, response => {
          self.getComments(); this.sending = false; this.$store.commit('hideProgressBar');
        });
      },

      //сохранение комментария
      saveComment(comment) {
        let self = this;
        if (comment.text.length > 0) {
          self.showCommentButton = false;
          comment.module_code = self.$props.module;

          this.$store.commit('showProgressBar');
          this.sending = true;

          if (typeof comment.id == 'undefined') {
            comment.entity = self.$props.entity;
            comment.entity_id = self.$props.entity_id;
            self.comment = {text: ''};
            self.$store.dispatch('comments/addComment', { comment: comment }).then(response => {
              self.getComments(); this.sending = false; this.$store.commit('hideProgressBar');
            }, response => {
              this.$store.commit('handleSnackError', [response, 6000, 'error']);
              this.$store.commit('hideProgressBar'); this.sending = false;
            });
          } else {
            this.$store.dispatch('comments/updateComment', { comment: comment }).then(response => {
              self.getComments(); this.sending = false; this.$store.commit('hideProgressBar');
            }, response => {
              this.$store.commit('handleSnackError', [response, 6000, 'error']);
              this.$store.commit('hideProgressBar'); this.sending = false;
            });
            comment.edit = 0; comment.oldText = '';
          }
        }
      },

      getComments() {
        if (this.issetData()) {
          this.$store.commit('showProgressBar');
          this.$store.dispatch('comments/getComments', {entity: this.$props.entity, entity_id: this.$props.entity_id}).then(response => {
            this.$store.commit('hideProgressBar');
            let comments = response.body.response; moment.locale('ru');
            //преобразовываем формат даты
            comments.forEach(comment => {
              comment.created_at = moment(comment.created_at).add(moment().utcOffset(), 'm').fromNow();
              comment.edit = 0
            });
            this.comments = comments;
          }, response => {
            this.$store.commit('hideProgressBar');
            this.$store.commit('showSnackbar', [response, 6000, 'error']);
          });
        }
      },

      //скрытие кнопки комментариев
      hideCommentButton() {
        if (this.comment.text.length == 0) this.showCommentButton = false
      },

      issetData() {
        return (
          this.$props.entity_id &&
          this.$props.module &&
          this.$props.entity &&
          typeof this.$props.entity_id === 'number' &&
          typeof this.$props.module === 'string' &&
          typeof this.$props.entity === 'string'
        );
      }
    }
  }
</script>
<style scoped lang="sass">
  .comments
    .items
      margin-top: 20px
    .comment
      margin-bottom: 20px
      .user
        font-weight: bold
        display: inline-block
      .date
        font-weight: 100
        display: inline-block
        margin-left: 15px
      .actions
        opacity: 0
        transition: all .3s
      &:hover .actions
        opacity: 1
</style>



// WEBPACK FOOTER //
// comments.vue?75601eaa